/**
 * 📦 Analytics Module
 *
 * 통합 Analytics 진입점입니다.
 * 이벤트 트래킹은 `Analytics.track()` 싱글톤을 사용합니다.
 *
 * @example
 * import { Analytics } from '@/features/common/analytics';
 *
 * // 이벤트 트래킹 (인라인 문자열 사용)
 * Analytics.track('View Mission Detail', { mission_id: '123' });
 *
 * // 페이지뷰 훅 사용
 * usePageViewTracking('View Leaderboard');
 */

// ============================================================================
// 🎯 Public API (기존 + 신규)
// ============================================================================

// Analytics Provider (신규 - Phase 7)
export { AnalyticsProvider } from './AnalyticsProvider';
export type { AnalyticsTracker } from './AnalyticsTracker';
// Global Analytics Tracker (전역 이벤트: Scroll, Time Spent)
export { GlobalAnalyticsTracker } from './GlobalAnalyticsTracker';
// Mixpanel (레거시 - Analytics.track() 사용 권장)
export { Mixpanel } from './mixpanel';
// 🎯 Analytics 싱글톤 (권장 API)
export { Analytics } from './tracker';

// 사용자 식별 훅 (신규)
export { useUserIdentity } from './useUserIdentity';

// ============================================================================
// 🎯 공통 트래킹 훅 (신규 - Phase 2)
// ============================================================================

export {
  useModalTracking,
  usePageViewTracking,
  useSectionViewTracking,
  useTabTracking,
} from './hooks';

// ============================================================================
// 🔧 Internal (DI container용)
// ============================================================================

// 기존 Trackers
export { CompositeAnalyticsTracker } from './CompositeAnalyticsTracker';
// 신규 Providers (Super Properties 지원)
export { MixpanelProvider, mixpanelReady, PopowCrmProvider } from './providers';
